import { Reseller as ResellerModel } from "../../../resellers/shared";

export class WhereToBuy {
  _id?: string;
  store: ResellerModel;
  url: string = "";
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/wheretobuy.model.ts